import { Injectable } from '@angular/core';
import { WidgetInterface } from '../interfaces/widget.interface';

@Injectable()
export class WidgetFactoryService {

    protected items: Array<WidgetInterface> = [];

    constructor() {
    }

    public add(widget: WidgetInterface): WidgetInterface {
        this.items.push(widget);

        return widget;
    }

    public remove(name: string): void {
        this.items = this.items.splice(this.items.findIndex((item) => {
            return item.name === name;
        }), 1);
    }

    public get(name: string): WidgetInterface {
        return this.items.find((item) => {
            return item.name === name;
        });
    }

    public all(): Array<WidgetInterface> {
        return this.items;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/services/widget-factory.service.ts